import React from "react";
import {
  Box,
  Typography,
  Card,
  CardHeader,
  CardContent,
  LinearProgress,
  Divider,
  Stack,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CancelIcon from "@mui/icons-material/Cancel";
import { colors } from "../../../css components/Style";

const AnimatedLinearProgress = ({ value }) => (
  <LinearProgress
    variant="determinate"
    value={value}
    sx={{
      height: 8,
      borderRadius: 4,
      backgroundColor: "rgba(0,0,0,0.06)",
      "& .MuiLinearProgress-bar": {
        backgroundColor: colors.sideBarColor,
        borderRadius: 4,
        transition: "transform 1.2s cubic-bezier(0.34, 1.56, 0.64, 1)",
      },
    }}
  />
);

const ChannelAnalyticsCard = ({ channel }) => {
  const stats = channel.stats_data || {};
  const initiated = stats.initiated || 0;
  //   const initiated = 22;
  const metrics = [
    {
      label: "Sent",
      value: stats.sent || 0,
      icon: <SendIcon sx={{ color: "#42a5f5" }} />,
      color: "#42a5f5",
    },
    {
      label: "Delivered",
      value: stats.delivered || 0,
      icon: <LocalShippingIcon sx={{ color: "#4caf50" }} />,
      color: "#4caf50",
    },
    {
      label: "Read",
      value: stats.read || 0,
      icon: <VisibilityIcon sx={{ color: "#9c27b0" }} />,
      color: "#9c27b0",
    },
    {
      label: "Failed",
      value: stats.failed || 0,
      icon: <CancelIcon sx={{ color: "#ef5350" }} />,
      color: "#ef5350",
    },
  ];

  return (
    <Card
      elevation={4}
      sx={{
        borderRadius: "20px",
        overflow: "hidden",
        height: "100%",
      }}
    >
      <CardHeader
        title={channel.channel_name || "WhatsApp"}
        titleTypographyProps={{
          fontSize: "1.25rem",
          fontWeight: 700,
          color: "#fff",
        }}
        sx={{
          background: colors.sideBarColor,
          color: "white",
          py: 2.5,
          px: 3,
        }}
      />

      <CardContent sx={{ p: 4, pt: 5 }}>
        <Box sx={{ textAlign: "center", mb: 5 }}>
          <Typography
            variant="h2"
            component="div"
            sx={{
              fontSize: { xs: "2.8rem", md: "3.5rem" },
              fontWeight: 700,
              color: colors.sideBarColor,
              lineHeight: 1,
              mb: 1,
            }}
          >
            {initiated.toLocaleString()}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: colors.sideBarColor,
              letterSpacing: "0.5px",
              mb: 0.5,
            }}
          >
            INITIATED
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: "0.95rem", fontWeight: 500 }}
          >
            Total Recipients
          </Typography>
        </Box>

        <Divider sx={{ mb: 4 }} />

        <Stack spacing={3.5}>
          {metrics.map((metric, index) => {
            const percentage =
              initiated > 0 ? Math.round((metric.value / initiated) * 100) : 0;

            return (
              <Box key={index}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1.5,
                    px: 0.5,
                    "&:hover": {
                      bgcolor: "action.hover",
                      borderRadius: 2,
                    },
                    transition: "background-color 0.2s",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    {metric.icon}
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, color: "text.primary" }}
                    >
                      {metric.label}
                    </Typography>
                  </Box>

                  <Box sx={{ textAlign: "right" }}>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 600, lineHeight: 1 }}
                    >
                      {metric.value.toLocaleString()}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "text.secondary",
                        fontWeight: 500,
                      }}
                    >
                      {percentage}%
                    </Typography>
                  </Box>
                </Box>

                <AnimatedLinearProgress value={percentage} />
              </Box>
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ChannelAnalyticsCard;
